export function distinctSortByTemplate(
  arr: string[],
  template: readonly string[],
) {
  const distinct = new Set(arr);
  return template.filter((e) => distinct.has(e));
}
